import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full px-4 md:px-6 py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20peach%20and%20cream%20tones%2C%20gentle%20flowing%20shapes%2C%20modern%20minimalist%20design%2C%20digital%20content%20creation%20theme%2C%20warm%20atmosphere&width=1600&height=500&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-foreground-950/50"></div>

      <div className="relative max-w-7xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          加入密桃视频，开启你的视频新世界
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          海量高清短视频内容，流畅播放体验，一键分享精彩。立即加入，发现更多乐趣！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-lg"></i>
            立即观看
          </button>
          <button
            onClick={() => navigate('/about')}
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 px-8 py-3 rounded-full font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </button>
        </div>
      </div>
    </section>
  );
}